import React, { Component, Fragment } from 'react'
import { Query, Mutation } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { SELECTED_BRANCH } from '../../constants'
import { SELF_QUERY } from '../../queries'
import { REPORT_ERROR } from '../../mutations'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import EmployeeCTA from '../../components/EmployeeCTA/'
import Loader from '../../components/Loader/'
import Error from '../../components/Error/'
import Form from '../../components/Form/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { Container, FlexContainer } from '../../styles/defaults'
import { MiniContainer, ContentContainer, Content } from './styles'

import hero from '../../assets/hero/storingmelden/hero.jpg'
import employee from '../../assets/cta/employee.png'
import helpers from '../../helpers'

class Faults extends Component {
  constructor(props) {
    super(props)
    this.getBase64 = this.getBase64.bind(this)
    this.getFiles = this.getFiles.bind(this)
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new window.FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        resolve(reader.result)
      }
      reader.onerror = error => {
        reject(error)
      }
    })
  }

  async getFiles(oldFiles) {
    return new Promise((resolve, reject) => {
      if (oldFiles) {
        let files = []
        oldFiles.map(async (file, index) => {
          files.push(await this.getBase64(file))
          if (oldFiles.length === files.length) {
            resolve(files)
          }
        })
      } else {
        resolve([])
      }
    })
  }

  render() {
    return (
      <Fragment>
        <Hero small={hero} medium={hero} large={hero} retina={hero} title="Storingen melden" />
        <Breadcrumb title="Storingen melden" />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="100%" fixed />
            if (error) return <Error error="de gebruikersgegevens" />
            const { self } = data
            let submitError = (self.permissions.includes('REPORT_ERROR') || self.role === 'MANAGER') && !this.props.branch.suspended

            let faultFormFields = [
              {
                name: 'machineNumber',
                label: 'Machine nummer*',
                value: '',
                type: 'text',
                required: 'required'
              },
              {
                name: 'message',
                label: 'Storing omschrijving*',
                value: '',
                type: 'textarea',
                required: 'required'
              },
              {
                name: 'files',
                label: "Foto's (max. 2)",
                value: '',
                type: 'file'
              }
            ]

            const selectedBranch = self.branches.find(
              branch =>
                (branch.id = window.localStorage.getItem(SELECTED_BRANCH)
                  ? window.localStorage.getItem(SELECTED_BRANCH)
                  : window.sessionStorage.getItem(SELECTED_BRANCH))
            )

            self.insertion = helpers.findInsertion(self.insertion)
            let fullName = self.firstName + ' ' + (self.insertion !== null ? self.insertion + ' ' : '') + self.lastName
            let submitted = false
            if (submitError) {
              return (
                <FlexContainer small full mt mb>
                  <MiniContainer>
                    <Mutation mutation={REPORT_ERROR}>
                      {(reportError, { data, loading, error }) => (
                        <Form
                          fields={faultFormFields}
                          submitText="Verzenden"
                          userId={this.props.match.params.id}
                          loading={loading}
                          error={error}
                          submitted={submitted}
                          onSubmitForm={async data => {
                            reportError({
                              variables: {
                                data: {
                                  to: process.env.REACT_APP_HOST_ENV === 'production' ? 'service@kaarskoffie.nl' : self.email,
                                  user: fullName,
                                  userId: self.id,
                                  branch: selectedBranch.name,
                                  branchId: selectedBranch.id,
                                  machineNumber: data.variables.data.machineNumber,
                                  message: data.variables.data.message,
                                  files: await this.getFiles(data.variables.data.files)
                                }
                              }
                            })
                              .then(() => {
                                this.props.history.push('/storing-melden/bedankt')
                              })
                              .catch(e => {
                                console.error(e)
                              })
                          }}
                          data={data}
                          succesMessage={'Uw bericht is verzonden'}
                        />
                      )}
                    </Mutation>
                  </MiniContainer>
                  <ContentContainer>
                    <Content>
                      <p>
                        Service to the boon. Wij zijn gedreven tot op het bot en gebrand op goede service. Zo doen onze
                        ervaren monteurs er alles aan om het ongemak dat u ervaart zo snel mogelijk te verhelpen.
                      </p>
                      <p>
                        Om u zo goed mogelijk van dienst te kunnen zijn, vragen wij u het formulier in te vullen. Zo
                        kunnen wij uw probleem binnen 24 uur verhelpen. Het krijgt bij ons top prioriteit!
                      </p>
                    </Content>
                    <EmployeeCTA
                      size={'medium'}
                      content={{
                        title: 'Vragen?',
                        subtitle: 'We helpen u graag',
                        employee: true,
                        image: employee,
                        link: {
                          content: 'Contact',
                          url: '/contact',
                          target: ''
                        }
                      }}
                    />
                  </ContentContainer>
                </FlexContainer>
              )
            } else {
              return (
                <Container mt mb>
                  Onvoldoende rechten om een storing te melden
                </Container>
              )
            }
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withRouter(withHeaderFooter(Faults))



// WEBPACK FOOTER //
// ./src/views/Faults/index.js